import { render, staticRenderFns } from "./ExtendableCardList.vue?vue&type=template&id=05c6d278"
import script from "./ExtendableCardList.vue?vue&type=script&lang=js"
export * from "./ExtendableCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports